import { render, staticRenderFns } from "./detail-info.vue?vue&type=template&id=07df2dfd&"
import script from "./detail-info.vue?vue&type=script&lang=js&"
export * from "./detail-info.vue?vue&type=script&lang=js&"
import style0 from "./detail-info.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports